<template>
  <header class="chart-header">
    <div class="title-section">
      <h2 class="chart-title">{{ title }}</h2>
      <p class="chart-subtitle">{{ subtitle }}</p>
    </div>
    
    <ChartLegend 
      v-if="showLegend"
      :items="legendItems"
      :hidden-series="hiddenSeries"
      :series-data="seriesData"
      :show-total="showTotalLegend"
      @toggle-series="$emit('toggle-series', $event)"
    />
  </header>
</template>

<script setup>
import ChartLegend from './ChartLegend.vue';

defineProps({
  title: {
    type: String,
  },
  subtitle: {
    type: String,
  },
  showLegend: {
    type: Boolean,
    default: false
  },
  legendItems: {
    type: Array,
    default: () => []
  },
  hiddenSeries: {
    type: Set,
    default: () => new Set()
  },
  seriesData: {
    type: Array,
    default: () => []
  },
  showTotalLegend: {
    type: Boolean,
    default: true
  }
});

defineEmits(['toggle-series']);
</script>

<style scoped>
.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.title-section {
  min-width: 0;
}

.chart-title {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
  padding: 0.3rem .5rem
}

.chart-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 4px 0 0 0;
  font-weight: 400;
  padding-left: .5rem;
}

@media (max-width: 768px) {
  .chart-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .chart-title {
    font-size: 18px;
  }
}
</style>